import { Fragment } from "react";
import ls from "local-storage";
import { Link } from "react-router";
import demoPalette from "../../utils/demo-palette.json";

/**
 * Home page layout that ensures a demo palette exists and lists local palettes.
 * @param {Object} props Component props
 */
const Layout = (props) => {
  let localPalettes = ls.get("palettes") || [];
  if (localPalettes.length === 0) {
    ls.set("palettes", [demoPalette]);
  }
  localPalettes = ls.get("palettes");

  return (
    <main className="site-main container">
      <div className="home-options">
        <div className="row">
          <div className="col-12 ">
            <h1>Color Palette Tool</h1>
            <Link to="/color-palette/">Create New Color Palette</Link>
            <p>
              This allows you to create a color palette with 10 lightness steps
              using the <a href="https://www.hsluv.org/">HSLuv color space</a>.
              This color space is designed for perceptual uniformity that allows
              for more consistent lightness steps across different hues and
              saturations. By creating a palette with consistent lightness
              steps, you can ensure that your color palette will have good
              contrast and accessibility across a wide range of colors making it
              easier for both designers and developers to create accessible
              designs.
            </p>
            <p>
              You may start with a hex value and check the value against
              prescribed lightness steps. The tool will create a side by side
              comparison of the original hex value and the closest matching
              lightness step.
            </p>
            <p>
              You can create a palette from scratch by selecting a hue and
              saturation and allowing the tool to generate lightness steps based
              on those values.
            </p>

            <p>
              Palettes are saved to local storage and can be accessed from the
              home page. You will also be able to export Sass or CSS variables
              to use in your projects.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <h2>Current Local Palettes</h2>
            <div>
              {localPalettes && (
                <Fragment>
                  <ul className="">
                    {localPalettes.map((palette, index) => {
                      return (
                        <li key={index}>
                          <Link to={`/color-palette/${palette.id}`}>
                            {" "}
                            {palette.paletteDetails.paletteName}{" "}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Layout;
